import { combineReducers } from 'redux'

import deleteNode from './executions/delete'
import get from './executions/get'
import post from './executions/post'
import put from './executions/put'
import view from './executions/view'

export default combineReducers({
  delete: deleteNode,
  get,
  post,
  put,
  view
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/executions.js